import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5667ed3e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "language-selector" }
const _hoisted_2 = { class: "p-inputgroup" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "p-inputgroup-addon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-globe" })
], -1))

import { ref, onBeforeMount } from "vue";
import PDropdown from "primevue/dropdown";
import Cookies from "js-cookie";
import i18n from "@/i18n";
import { usePrimeVue } from "primevue/config";
import { getCurrentLanguagePreference } from "@/assets/utils/GetCurrentLanguagePreference";


export default /*#__PURE__*/_defineComponent({
  __name: 'languageSwitcher',
  setup(__props) {

const selectedLanguage = ref();
const primevue = usePrimeVue();
const languageOptions = [
  { name: "English", value: "en" },
  { name: "French", value: "fr" },
  // Add more languages as needed
];

const changeLanguage = () => {
  Cookies.set("selectedLanguage", selectedLanguage.value, {
    expires: 365,
  });
  i18n.global.locale.value = selectedLanguage.value;

  // eslint-disable-next-line @typescript-eslint/no-var-requires
  const primevueTrads = require(`@/locales/primevue/${selectedLanguage.value}.json`);
  console.log(primevueTrads, primevue.config.locale);
  primevue.config.locale = primevueTrads;
};

onBeforeMount(() => {
  selectedLanguage.value = getCurrentLanguagePreference();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_unref(PDropdown), {
        options: languageOptions,
        modelValue: selectedLanguage.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedLanguage).value = $event)),
        optionLabel: "name",
        "option-value": "value",
        "data-key": "value",
        onChange: changeLanguage
      }, null, 8, ["modelValue"])
    ])
  ]))
}
}

})